export const CRYPTO_KEY = 'M/pVisy6asgrBNob+KRG6A=='
